var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-bubble"},[_c('div',{staticClass:"content"},[_vm._t("default")],2),(_vm.caption !== undefined)?_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }